
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class PresentationUtilsService {

    constructor() { }

    /**
     * @param empaqueCode
     * @param umCode
     * @param quantity
     * @returns
     */
    calculatePresentationCode(empaqueCode: string, umCode: string, quantity: number): string {
        if (!empaqueCode || !umCode || quantity === null || quantity === undefined) {
            return '';
        }

        let newQuantity = quantity;
        let newUmCode = umCode;

        if (newUmCode === '02' && newQuantity > 999.9) {
            newQuantity = newQuantity / 1000;
            newUmCode = '01';
        } else if (newUmCode === '01' && newQuantity > 999.9) {
            newQuantity = newQuantity / 1000;
            newUmCode = '06';
        } else if (newUmCode === '06' && newQuantity > 999.9) {
            newQuantity = newQuantity / 1000;
            newUmCode = '07';
        } else if ((newUmCode === '04' || newUmCode === '05') && newQuantity > 999.9) {
            newQuantity = newQuantity / 1000;
            newUmCode = '03';
        } else if (newUmCode === '03' && newQuantity > 999.9) {
            newQuantity = newQuantity / 1000;
            newUmCode = '08';
        }

        const roundedQuantity = Math.round(newQuantity * 10) / 10;


        const integerPart = Math.trunc(roundedQuantity);

        const decimalDigit = Math.round((roundedQuantity * 10) % 10);

        const integerString = integerPart.toString().padStart(3, '0');
        const decimalString = decimalDigit.toString();

        const quantityCode = (integerString + decimalString).substring(0, 4);

        return `${empaqueCode}${quantityCode}${newUmCode}`;
    }
}
